export const filterOptionsHelper = (arr: any, value: string) => {
  const fileredObject = arr.filter(o => o.name === value)
  return fileredObject && fileredObject[0] && fileredObject[0].active
}



// WEBPACK FOOTER //
// ./src/helpers/filterOptionsHelper.ts